<span class="text" (click)="copyToClipboard()">{{text}}</span>
